import { AiInsDetectionResponse } from "../../../components/Shared/voice-instructions/Models/ai-model.model";
import {OrgBUProjectTeamStructure} from "../../../models/custom-models/org-buproject-team-structure";

export const BOT_MODE = {
    INFO: "INFO",
    TSE: "TSE",
} as const;
export type BotMode = keyof typeof BOT_MODE;

export class ChatCommands {
    message: string;
    command: number;
    senderString: string;

    constructor(message: string, command: ChatCommandsEnum) {
        this.message = message;
        this.command = command;
        this.senderString = getChatCommandsEnumKeyByValue(command);
    }
}

export function getChatCommandsEnumKeyByValue(value: number): string {
    return ChatCommandsEnum[value];
}

export enum ChatCommandsEnum {
    userInput,
    aiFollowBack,
    error,
    aiInformationalMessage,
}

export enum FollowBackAiInstructionEnum {
    taskNumber,
    isReplaceDescription,
    teamName,
    statusChange,
    effort,
    userPerceivedPercentage,
    joinMeetingID,
    noteDescription,
    comment,
    organizationName,
    person,
    actualStartDate,
}

export const GreetingHelpBotMessage =
    "Hi! 👋 I'm InfoBot, here to help you navigate and understand this application platform.\n" +
    " \n" +
    "What would you like to know today? I'll do my best to assist you!";

export const GreetingTSeBotMessage =
    "\"Hi! 👋 My name is TSeBot, your virtual assistant. Please let me know what you need or want done, and I'll do my best to assist!";

// + " \n" + 'If you are unsure, type "00" to see the list of commands that showcase my capabilities. \n';

export class ChatHelpRequest {
    query: string;

    request_id: string; // @deprecated
    search_size: number; // @deprecated

    constructor(query: string) {
        this.query = query;
        // this.request_id = UUID.UUID();
        // this.search_size = 2;
    }
}

export enum VIJAYI_ASSISTANTS {
    InfoBot = 1,
    TSeBot = 2,
}

// {
//     "response": "Tasks can be created from 3 places within the application:\nStep 1. a. Navbar - Hover over the '+' icon and click 'Create'\n            b. Dashboard\n            c. Task Master\n\nStep 2. Choose 'Create Task'.\nStep 3. Choose the team you want to create the task in.\nStep 4. Fill all the other required fields.",
//     "status": 200,
//     "timeTaken": 3.1652016639709473
// }

export class ChatHelpResponse {
    response: string;
    status: number;
    timeTaken: number;
    gifs: Gif[];
}

export interface Gif {
    gif_blob: string;
    gif_title: string;
    gif_enum: string;
    gif_tags: string[];
    gif_text: string;
}

export interface FollowBackState {
    isActive: boolean;
    type: FollowBackAiInstructionEnum;
    context: AiInsDetectionResponse;
}
export interface FollowBackStateList {
    isActive: boolean;
    type: FollowBackAiInstructionEnum[];
    context: AiInsDetectionResponse;
}

export interface ProcessedData {
    personNames: string[];
    entity: {
        entityType: string;
        entityTypeId: number;
        entityId: number;
        entityName: string;
        orgId: number;
        projectId: number | null;
        teamId: number | null;
    };
    startDate: Date;
    endDate: Date;
    accountIds: string; // Account IDs of the logged-in user
    node: OrgBUProjectTeamStructure;
}